<template>
  <div class="position-relative">
    <el-dialog
      top="2vh"
      v-if="replaceBadWord.show"
      :title="'Tin nhắn gửi đi có chứa ' + replaceBadWord.items.length + ' từ khóa nhạy cảm'"
      width="500px"
      :visible.sync="replaceBadWord.show"
      :close-on-click-modal="false"
      :destroy-on-close="true">
      <div>
        <div>
          <div class="d-flex fw-bolder font-size-14 mb-3">
            <div class="w-150px">Từ cấm</div>
            <div class="flex-1">Từ thay thế</div>
            <div style="width: 60px"></div>
          </div>
          <div class="divider-custom"></div>
          <div style="max-height: 200px; overflow-y: auto">
            <div
              v-for="(item, index) in replaceBadWord.items"
              :key="index">
              <div class="d-flex font-size-14 my-2">
                <div class="w-150px">
                  <div class="d-flex">
                    <div class="">{{ item.key }}</div>
                  </div>
                </div>
                <div class="flex-1">
                  <el-input
                    placeholder="Nội dung thay thế"
                    @input="handleInputReplace(item)"
                    v-model="item.replace"></el-input>
                </div>
              </div>
              <div class="divider-custom"></div>
            </div>
          </div>
        </div>
        <div class="my-2">Nội dung sau chỉnh sửa</div>
        <el-input
          ref="inputText"
          resize="none"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 5 }"
          v-model="replaceBadWord.content"
          disabled />
        <div class="d-flex justify-content-end mt-2">
          <el-button
            size="sm"
            plain
            type="danger"
            @click="closeReplaceBadWord()">
            Hủy
          </el-button>
          <el-button
            size="sm"
            type="primary"
            @click="sendReplace()">
            Gửi tin nhắn
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :destroy-on-close="true"
      v-if="visibleRequestFriend"
      :visible.sync="visibleRequestFriend"
      title="Gửi yêu cầu kết bạn">
      <div class="p-2">
        <el-input
          type="textarea"
          row="3"
          v-model="textRequestFriend"></el-input>
        <div class="d-flex justify-content-end align-items-center mt-3">
          <el-button
            plain
            type="danger"
            @click="$emit('close')"
            size="small">
            Huỷ
          </el-button>
          <el-button
            plain
            type="primary"
            @click="addFriend()"
            size="small">
            Xác nhận
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "RequestFriendBoxV2",
  props: {
    data: Object,
    visibleRequestFriend: Boolean,
    requestStatus: Object,
  },
  data() {
    return {
      requestFriend: {},
      textRequestFriend: "Xin chào kết bạn với mình nhé!",
      replaceBadWord: {
        show: false,
        items: [],
        content: "",
      },
    };
  },
  watch: {
    data() {
      this.textRequestFriend = "Xin chào " + this.data.displayName + ", kết bạn với mình nhé!";
    },
  },
  methods: {
    closeReplaceBadWord() {
      this.replaceBadWord.show = false;
    },
    handleInputReplace() {
      this.replaceBadWord.items.forEach((it) => {
        for (let item of this.filterCharacterArr()) {
          if (it.replace.toLowerCase() == item.content.toLowerCase()) {
            it.replace = "****";
          }
        }
      });
      this.replaceBadWordContent();
    },
    deleteReplace(item) {
      let filter = this.replaceBadWord.items.filter((con) => con.key == item.key);
      if (filter != null && filter.length > 0) {
        const index = this.replaceBadWord.items.indexOf(filter[0]);
        if (index > -1) {
          this.replaceBadWord.items.splice(index, 1);
          this.replaceBadWordContent();
        }
      }
    },
    filterCharacterArr() {
      const characterArr = this.app.characterFilters;
      const arrCommon = characterArr["0"];
      const arrOnwerAccount = characterArr[this.data.accountId];
      let array = [];
      if (arrCommon && arrCommon.length > 0) {
        array.push(...arrCommon);
      }
      if (arrOnwerAccount && arrOnwerAccount.length > 0) {
        array.push(...arrOnwerAccount);
      }
      const key = "content";
      const unique = [...new Map(array.map((item) => [item[key], item])).values()];
      return unique;
    },
    replaceBadWordContent() {
      this.replaceBadWord.content = this.textRequestFriend;
      this.replaceBadWord.items.forEach((item) => {
        this.replaceBadWord.content = this.replaceBadWord.content.replaceAll(item.key, item.replace);
      });
    },
    filterCharacter() {
      let items = [];
      let check = true;
      let fil = this.app.accountSetting.filter((p) => p.accountId == this.data.accountId);
      if (fil != null && fil.length > 0) {
        check = fil[0].checkBadWord;
      }
      if (check) {
        let text = this.textRequestFriend;
        let arr = text.split(" ");
        if (this.filterCharacterArr() && this.filterCharacterArr().length > 0 && arr.length > 0) {
          for (let item of this.filterCharacterArr()) {
            arr.forEach((it) => {
              if (it.toLowerCase() == item.content.toLowerCase()) {
                let fil = items.filter((f) => f.key == it);
                if (fil == null || fil.length == 0) {
                  items.push({ key: it, replace: "****" });
                }
              }
            });
          }
        }
      }
      return items;
    },
    async addFriend() {
      let items = this.filterCharacter();
      if (items.length > 0) {
        this.replaceBadWord.show = true;
        this.replaceBadWord.items = items;
        this.replaceBadWordContent();
      } else {
        this.send();
      }
    },
    sendReplace() {
      this.textRequestFriend = this.replaceBadWord.content;
      this.send();
    },
    send() {
      // this.visibleRequestFriend = false;
      this.$http
        .get("/api/contact/addFriend", {
          params: {
            userId: this.data.userId,
            accountId: this.data.accountId,
            msg: this.textRequestFriend,
          },
        })
        .then(async (resp) => {
          if (resp.data.error_code === 0) {
            this.alert("success", "Gửi kết bạn thành công");
          } else if (resp.data.error_code === 222) {
            this.$set(this.data, "isFr", 1);
          } else if (resp.data.error_code !== 0) {
            return this.alert("error", resp.data.error_message);
          }
        });

      this.replaceBadWord.show = false;
      this.replaceBadWord.items = [];
      this.replaceBadWord.content = "";
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>
